module.exports = __webpack_public_path__ + "img/category.41c43b8c.png";